import countries from './countries.raw.json';
import { CountryAlpha3Code, CountryList } from './countries';

export interface ICountry {
  alpha2: CountryList;
  alpha3: string;
  countryCode: string;
  intermediateRegion: string;
  intermediateRegionCode: string;
  'iso_3166-2': string;
  name: string;
  region: string;
  regionCode: string;
  subRegion: string;
  subRegionCode: string;
  isTopCountry: boolean;
  disabled: boolean;
  currency?: string;
}

export type Countries = Record<CountryList, ICountry>;

export const allCountries = Object.values(countries as Countries).filter(({ disabled }) => !disabled);
export const topCountries: ICountry[] = allCountries.filter(({ isTopCountry, disabled }) => !disabled && isTopCountry);
export const otherCountries: ICountry[] = allCountries.filter(({ isTopCountry, disabled }) => !disabled && !isTopCountry);
export const countryNames = allCountries.map(({ name }) => name);
export const getCountriesWithCurrencies: ICountry[] = allCountries.filter(({ currency }) => currency);
export const countriesByAlpha3Code = allCountries.reduce((acc, next) => {
  /* eslint-disable-next-line no-param-reassign */
  acc[next.alpha3 as CountryAlpha3Code] = next;
  return acc;
}, {} as Record<CountryAlpha3Code, ICountry>);

export const useCountriesAsSelect = (list: ICountry[] = allCountries, keyName: keyof ICountry = 'alpha3', valueName: keyof ICountry = 'name') =>
  list.map((country) => ({ key: country[keyName], value: country[valueName] }));

// Trading timezones (?)
export const COUNTRY_TIMEZONE_MAP: Partial<Record<CountryList, string>> = {
  AU: 'Australia/Sydney',
  US: 'America/New_York',
  NZ: 'Pacific/Auckland',
  ES: 'Europe/Madrid',
  DK: 'Europe/Copenhagen',
  SE: 'Europe/Stockholm',
  HK: 'Asia/Hong_Kong',
  SG: 'Asia/Singapore',
  JP: 'Asia/Tokyo',
  GB: 'Europe/London',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  CA: 'America/Toronto',
  NL: 'Europe/Amsterdam',
  CH: 'Europe/Zurich',
  BE: 'Europe/Brussels'
};
